import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: null,
  errmsg: "",
  user: {},
  isLoggedin: false,
  profileBoxAction:false
};

const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {
    setIsLoggedin(state, action) {
      state.isLoggedin = action.payload.isLoggedin;
    },
    getToken(state, action) {
      state.token = action.payload.token;
    },
    setError(state, action) {
      state.errmsg = action.payload.errmsg;
    },
    setUser(state, action) {
      state.user = action.payload.user;
    },
    setProfileBoxAction(state, action) {
      state.profileBoxAction = action.payload.profileBoxAction;
    },
  },
});

export const { setIsLoggedin, getToken, setError, setUser,setProfileBoxAction } = authSlice.actions;
export const authReducer = authSlice.reducer;
